module.exports = __webpack_public_path__ + "img/车明海.8ad31739.jpg";